import { normalize } from "normalizr";
import { projectItem} from "./schema";


export const getProjectsFromFile = {
  success: (response) => {
    return normalize(response, [projectItem]);
  },
};
